module.exports = __webpack_public_path__ + "img/file-add.de945e6f.png";